/** Màn chờ toàn trang — dùng khi chưa xác định được phiên đăng nhập. */
export function FullScreenLoader() {
  return (
    <div className="bg-canvas flex min-h-screen items-center justify-center">
      <div className="border-accent h-10 w-10 animate-spin rounded-full border-4 border-t-transparent" />
    </div>
  );
}
